import { useQuery } from "@tanstack/react-query";

import { billingQueriesStore } from "../api";

export const useActiveSubscriptions = () => {
  return useQuery(billingQueriesStore.subscriptions._ctx.active);
};
